export const rolesType = {
  admin: "super_user",
  user: "user",
  client: "client",
};

